import React from "react";
import PagerHero from "../PageHero/PageHero";
import { ProjectDetails } from "../../lib/ProjectDetails";

const Projects = () => {
  return (
    <main className="project-container">
      <PagerHero
        headline="Spotlight Projects"
        description="Explore our project spotlights, showcasing innovative solutions in renewable energy, advanced data centers, and critical infrastructure, driving sustainability and efficiency worldwide."
      />

      {ProjectDetails.map((project) => (
        <article
          key={project.id}
          className="project-details"
          aria-labelledby={`project-title-${project.id}`}
          aria-describedby={`project-desc-${project.id}`}
        >
          <div className="img-container">
            <img
              src={project.image}
              alt={project.alt || project.title}
              className="photo"
              loading="lazy"
            />
          </div>
          <div className="content">
            <h2 id={`project-title-${project.id}`} className="title">
              {project.title}
            </h2>
            <p id={`project-desc-${project.id}`} className="description">
              {project.desc}
            </p>
          </div>
        </article>
      ))}
    </main>
  );
};

export default Projects;
